import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PrestamosService } from '../../../services/prestamos.service';

@Component({
  selector: 'app-historial-pago-prestamo',
  templateUrl: './historial-pago-prestamo.component.html',
  styleUrls: ['./historial-pago-prestamo.component.css']
})
export class HistorialPagoPrestamoComponent implements OnInit {
  @Input() ID_PRESTAMO: any;
  loading = false;
  completado = false;
  nombreCliente: string;
  historial = [];
  loaded = false;
  constructor(
    public activeModal: NgbActiveModal,
    private prestamoService: PrestamosService) { }

  ngOnInit() {
    this.initHistorial();
  }

  private initHistorial() {
    this.prestamoService.historialPagos(this.ID_PRESTAMO).subscribe((res: any) => {
      if (res.length > 0) {
        this.historial = res;
      }
      this.loaded = true;
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/historial-pago-prestamo/historial-pago-prestamo.component.ts